import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
    const { data } = await api.post("/contact", payload);
    return data;
}

export async function submitAssessment(payload) {
    const { data } = await api.post("/assessment", payload);
    return data;
}

/**
 * Streams chat tokens via fetch + ReadableStream parsing of SSE.
 * onEvent receives objects of shape:
 *  { type: "session", session_id }
 *  { type: "delta", content }
 *  { type: "done" }
 *  { type: "error", message }
 */
export async function streamChat({ message, sessionId, onEvent, signal }) {
    const res = await fetch(`${API_BASE}/chat/stream`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message, session_id: sessionId }),
        signal,
    });
    if (!res.ok || !res.body) {
        throw new Error(`Chat request failed: ${res.status}`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop() || "";
        for (const part of parts) {
            const line = part.trim();
            if (!line.startsWith("data:")) continue;
            const payload = line.slice(5).trim();
            if (!payload) continue;
            try {
                const obj = JSON.parse(payload);
                onEvent(obj);
            } catch {
                /* ignore malformed line */
            }
        }
    }
}
